import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Loader from 'src/app/components/Loader';
import { sendRegistrationEventFromUrl } from 'src/app/redux/actions/registrationTracker';


class RegistrationTrackerContainer extends React.PureComponent {

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(sendRegistrationEventFromUrl());
  }

  render() {
    return <Loader/>;
  }
}


RegistrationTrackerContainer.propTypes = {
  dispatch: PropTypes.func.isRequired
};

export default connect()(RegistrationTrackerContainer);
